import { Counter } from "@/components/ui/counter";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo, useCallback } from "react";

interface IngredientsServingSelectorProps {
  mealDay?: string;
  servings: number;
  onServingsChange: (newServings: number) => void;
}

/**
 * Servings selector for ingredients modal
 * Allows user to adjust serving size which scales ingredient quantities
 */
export const IngredientsServingSelector = memo(function IngredientsServingSelector({
  servings,
  onServingsChange,
}: IngredientsServingSelectorProps) {
  const handleCountChange = useCallback(
    (newCount: number) => {
      onServingsChange(newCount);
    },
    [onServingsChange],
  );

  return (
    <div className="relative z-10 flex w-full items-center justify-between rounded-2xl bg-white/16 px-4 py-1 shadow-sm">
      <h3 className={cn(textVariants.bodySingleLine)}>Servings</h3>

      <div className="flex items-center gap-3">
        <span className={cn(textVariants.bodySingleLine, "font-bold")}>{servings}</span>
        <Counter value={servings} onChange={handleCountChange} min={1} max={10} />
      </div>
    </div>
  );
});
